import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const riskTableContainer = () => css`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
`
export const riskTable = ({ theme }: { theme: Theme }) => css`
  padding: ${theme.spacing(6)} ${theme.spacing(8)};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(2)};
  flex-grow: 1;
  overflow: auto;
`
export const dataGridContainer = ({ theme }: { theme: Theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(4)};
  color: #0b2948;
  border: none;
  padding-bottom: ${theme.spacing(1)};
  flex-grow: 0;
  flex-shrink: 0;

  .MuiDataGrid-columnSeparator {
    opacity: 0;
    bottom: 0;
    height: 200%;
  }
  .MuiDataGrid-rowSeparator {
    display: none;
  }
  .MuiDataGrid-columnHeader:not([aria-colindex='1']) {
    border-left: 1px solid #0b294830;
    div {
      flex-direction: row;
      font-weight: 600;
    }
  }
  .MuiDataGrid-columnHeader--last {
    border-right: 1px solid #0b294830;
  }
  [aria-rowindex='1'] .MuiDataGrid-columnHeader:not([aria-colindex='1']) {
    border-bottom: 1px solid #0b294830;
    border-top: 1px solid #0b294830;
    height: auto !important;
    padding: ${theme.spacing(1)} ${theme.spacing(2)};

    .MuiDataGrid-columnHeaderTitleContainer {
      border-bottom: none;
      .MuiDataGrid-columnHeaderTitle {
        white-space: normal;
        line-height: 1.4;
      }
    }
  }
  [aria-rowindex='2'] .MuiDataGrid-columnHeader {
    border-bottom: 2px solid #0b294830;
    max-height: 32px;
    div {
      font-weight: 500;
    }
  }
  [aria-colindex='1'].MuiDataGrid-cell {
    font-weight: 500;
  }
  .MuiDataGrid-cell {
    border-color: #0b294830;
  }
  .MuiDataGrid-cell:not([aria-colindex='1']) {
    background-color: #0b294804;
  }
  .MuiDataGrid-cell {
    border-left: 1px solid #0b29480f;
    cursor: pointer;
  }
  .MuiDataGrid-cell:focus {
    outline: none;
  }
  .MuiDataGrid-cell.first-in-group {
    border-left: 1px solid #0b294830;
  }
  .MuiDataGrid-filler {
    --rowBorderColor: #0b294830 !important;
  }
  [aria-colindex='1'].MuiDataGrid-cell {
    border-left: 1px solid #0b294830;
  }

  div {
    &::-webkit-scrollbar {
      height: 8px !important;
      width: 8px !important;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #0b2948a0 !important;
      border-radius: 2px !important;
    }

    &::-webkit-scrollbar-track {
      background-color: #0b294810 !important;
      border-radius: 2px !important;
    }
  }

  .heat-0 {
    box-shadow: inset 0 0 0 1000px #0b397802;
  }
  .heat-1 {
    box-shadow: inset 0 0 0 1000px #0b397804;
  }
  .heat-2 {
    box-shadow: inset 0 0 0 1000px #0b397806;
  }
  .heat-3 {
    box-shadow: inset 0 0 0 1000px #0b397808;
  }
  .heat-4 {
    box-shadow: inset 0 0 0 1000px #0b39780a;
  }
  .heat-5 {
    box-shadow: inset 0 0 0 1000px #0b39780c;
  }
  .heat-6 {
    box-shadow: inset 0 0 0 1000px #0b39780e;
  }
  .heat-7 {
    box-shadow: inset 0 0 0 1000px #0b397810;
  }
  .heat-8 {
    box-shadow: inset 0 0 0 1000px #0b397812;
  }
  .heat-9 {
    box-shadow: inset 0 0 0 1000px #0b397814;
  }
  .heat-10 {
    box-shadow: inset 0 0 0 1000px #0b397816;
  }
`

export const tableContainer = ({ theme }: { theme: Theme }) => css`
  width: 100%;
  overflow: auto;
  height: min-content;
  flex-grow: 1;
  flex-direction: column;
  display: flex;
  margin-top: ${theme.spacing(4)};

  > div {
    overflow: auto;
    flex-grow: 1;
  }

  th {
    line-height: 1.4;
  }

  td:nth-of-type(2n + 1) {
    background-color: ${theme.palette.primary.main}04;
  }
  td:first-of-type {
    background-color: ${theme.palette.primary.main}00;
    border-right: 1px solid ${theme.palette.primary.main}20;
    font-weight: 500;
    color: ${theme.palette.primary.main};
  }

  tr:last-of-type td {
    color: ${theme.palette.primary.main};
    font-weight: 600;
    border-top: 1px solid ${theme.palette.primary.main}40;
    border-bottom: none;
    padding-top: ${theme.spacing(2)};
    position: relative;

    &:before {
      content: '';
      display: block;
      border-top: 1px solid ${theme.palette.primary.main}20;
      width: 100%;
      position: absolute;
      top: 1px;
      left: 0;
    }
  }
`
